import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, FlatButton } from 'material-ui'
import styles from './styles.css'

const ConfirmDeleteDialog = ({ bookingPatientId, closeDialog, handleConfirm }) => (
  <Dialog
    open={!!bookingPatientId}
    onRequestClose={closeDialog}
    contentStyle={{ width: '500px' }}
    zDepth={10}
  >
    <div className={styles.dialogContainer}>
      <h2>Are you sure you want to delete this patient and appointment?</h2>
      <div className={styles.dialogButton}>
        <FlatButton
          label="Confirm"
          primary
          onClick={() => handleConfirm(bookingPatientId)}
        />
        <FlatButton
          label="Cancel"
          secondary
          onClick={closeDialog}
        />
      </div>
    </div>
  </Dialog>
)

ConfirmDeleteDialog.propTypes = {
  bookingPatientId: PropTypes.number,
  closeDialog: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
}

export default ConfirmDeleteDialog



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/ConfirmDeleteDialog.js